





























import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;

  status = "0";

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "你确定要修改设置吗？",
          onOk: async () => {
            const res = await this.$store.dispatch("oplatformapps/changewxasearchstatus", {
              appid: this.appid,
              status: fieldValues.status
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
          }
        });
      }
    });
  }

  mounted() {
    this.$store
      .dispatch("oplatformapps/getwxasearchstatus", {
        appid: this.appid
      })
      .then(res => {
        if (res && res.Data) {
          this.status = res.Data;
        }
      });
  }
}
